/* eslint no-spaced-func: "warn"*/
/* eslint func-call-spacing: "warn"*/
/* eslint no-unexpected-multiline: "warn"*/

/** @ngInject */
function tagManagerRun($window, $location) {
    let trackerId
    if (['local.unergie.com', 'espace-client.int.plum.fr', 'espace-client.preprod.plum.fr'].indexOf($location.host()) > -1) {
        trackerId = 'GTM-MVKHSXZ'
    }
    if (['plum-energie.fr', 'espace-client.plum.fr'].indexOf($location.host()) > -1) {
        trackerId = 'GTM-WL84WGW'
    }


    // Google Tag Manager
    (function (w, d, s, l, i) {
        w[l] = w[l] || []
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
        const f = d.getElementsByTagName(s)[0]
        const j = d.createElement(s)
        const dl = l !== 'dataLayer' ? `&l=${l}` : ''
        j.async = true
        j.src = `https://www.googletagmanager.com/gtm.js?id=${trackerId}${dl}`
        f.parentNode.insertBefore(j, f)
    }(window, document, 'script', 'dataLayer', trackerId))
}

export default tagManagerRun



// WEBPACK FOOTER //
// ./src/config/tagmanager.js